export { ChatSelectionProvider, useChatSelection } from './ChatIdContext';
export type { ChatSelectionContextType } from './ChatIdContext';

// Backwards compatibility aliases
export { ChatIdProvider, useChatId } from './ChatIdContext';
export type { ChatIdContextType } from './ChatIdContext';

// Chat data context for centralized state management
export { ChatDataProvider, useChatData } from './ChatDataContext';
export type { ChatDataContextType } from './ChatDataContext';

// Entity context for entity-focused chats
export { EntityContextProvider, useMeridianEntityContext, useMeridianEntityContextOptional } from './EntityContextProvider';
export type { MeridianEntityContextData } from './EntityContextProvider';